(function () {

  'use strict';

  /**
   * @author Ronald Nicholls
   * @class ute-ui.datePicker
   * @description Extends the Angular Bootstrap UI Date Picker. Angular Bootstrap UI is required to use this
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .constant('moment', moment)

    .directive('uteDatePicker', function () {

      return {
        scope: {
          endDate: '=',
          ngModel: '=',
          navigate: '=',
          preSelectDate: '@'
        },
        transclude: true,
        template: '<i class="ute-icon-calendar ute-xl" show-button-bar="false" datepicker-popup="{{format}}" ng-click="open($event)" ng-model="ngModel" is-open="opened" min-date="minDate" max-date="maxDate" datepicker-options="dateOptions"></i>',
        restrict: 'E',
        controller: ['$scope', function ($scope) {

          /**
           * Open function used to trigger datepicker pop overz
           * @event required to prevent bubble up
           */
          $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.opened = true;
          };

          /**
           * If preSelectDate = today, set it today, else make it null
           * TODO: Add abillity to add a UTC date that will be selected
           */
          $scope.ngModel = $scope.preSelectDate || moment().format();

          /**
           * Clear functiont that will clear the selecte date and put it back to null
           */
          $scope.clear = function () {
            $scope = null;
          };

          /**
           * Set MinDate.
           * ToDo: Add ability to set min date from outside directive. If no min date is set, than there is no min date
           */
          $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : moment().format();
          };
          $scope.toggleMin();

          /**
           * Set max date date range.
           * ToDo: If no max date is set, than there is no max date
           */
          $scope.maxDate = moment().add($scope.endDate, 'd');

          /**
           * Date options. Year Format, and Starting Day;
           * Starting day of the week from 0-6 (0=Sunday, ..., 6=Saturday)
           * maxMode day will dissable year / month navigation
           */
          $scope.dateOptions = { formatYear: 'yy', startingDay: 1, maxMode: 'day', showWeeks: false };


          /**
           * Array of date formats
           */
          $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];

          /**
           * set date format
           */
          $scope.format = $scope.formats[0];

        }]

      };
    });

})();
